import React from "react";

function SectionTitle({ children }) {
  return (
    <h2 className="text-lg leading-6 font-medium text-gray-900">{children}</h2>
  );
}

export default React.memo(SectionTitle);
